import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardTitle, Row, Col, Input, Button, Label } from "reactstrap"
import { DetalleParametrosProyeccionHE } from '../TypesParametrosHorasExtras'
import DatePickerBlueColor from 'components/Varios/DatePicker/DatePickerBlueColor'
import { isWeekday } from 'functions/CalendarFunctions'
import { SumarDiasFecha } from 'functions/DatesFunctions'
import Parametros from '../Parametros'


type PropsCardPeriodosProyeccionHE = {
    parametros: DetalleParametrosProyeccionHE | null | undefined,
    onChangeFecha(tipo: string, value: string): void;
}

export default function CardPeriodosProyeccionHE(props: PropsCardPeriodosProyeccionHE) {

    const fechaActual = new Date();
    const anioActual = fechaActual.getFullYear();
    const ultimaFechaAnio = new Date(anioActual, 11, 31, 0, 0, 0);

    //STATES PARA PROYECCION
    const [stateinicioproyeccion, setstateinicioproyeccion] = useState<string | null>(null)

    const [statefinproyeccion, setstatefinproyeccion] = useState<string | null>(null)

    const [stateinicioproyeccionextr, setstateinicioproyeccionextr] = useState<string | null>(null)
    const [statefinproyeccionextr, setstatefinproyeccionextr] = useState<string | null>(null)


    const [stateinicioasigpresup, setstateinicioasigpresup] = useState<string | null>(null)
    const [statefinasigpresup, setstatefinasigpresup] = useState<string | null>(null)

    

    useEffect(() => {
        if(props.parametros){
            //PERIODO PROY
            setstateinicioproyeccion(props.parametros.fechainicioproyeccion);
            setstatefinproyeccion(props.parametros.fechafinproyeccion);
            //ASIG PRESUP
            setstateinicioasigpresup(props.parametros.fechainicioasigpresupGPE);

            setstatefinasigpresup(props.parametros.fechafinasigpresupGPE)
            //PROY EXTRA
            setstateinicioproyeccionextr(props.parametros.fechainicioproyeccionextr); 
            setstatefinproyeccionextr(props.parametros.fechafinproyeccionextr)
        }
        else{
            //PERIODO PROY
            setstateinicioproyeccion(null);
            setstatefinproyeccion(null);
            //ASIG PRESUP
            setstateinicioasigpresup(null);
            setstatefinasigpresup(null);
            //PROY EXTRA
            setstateinicioproyeccionextr(null);
            setstatefinproyeccionextr(null);
        }
    }, [props.parametros])
    


    const DatePickerFinProyeccion = useMemo(() => {

        var minDate = new Date();

        if (stateinicioproyeccion !== null) {
            const inicioproyeccionDate = new Date(stateinicioproyeccion);
            minDate = SumarDiasFecha(inicioproyeccionDate, 1);
        }
        else {
            minDate = SumarDiasFecha(minDate, 1);
        }

        return (
            <DatePickerBlueColor
                value={statefinproyeccion}
                disabled={stateinicioproyeccion === null}
                name="fechafinproyeccion"
                id="fechafinproyeccion"
                onChange={(e) => { setstatefinproyeccion(e) }}
                min={minDate}
                max={ultimaFechaAnio}
                filter={(date: Date) => isWeekday(date)}
                monthdropdown={true}
            // showDisabledMonthNavigation={true}
            // excludeDates={excludeDates}
            // dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        )


    }, [stateinicioproyeccion, statefinproyeccion])


    const DatePickerInicioProyeccionExtraordinaria= useMemo(() => {

        var minDate = new Date();

        if (statefinproyeccion !== null) {
            const inicioproyeccionExtrDate = new Date(statefinproyeccion);
            minDate = SumarDiasFecha(inicioproyeccionExtrDate, 1);
        }
        else {
            minDate = SumarDiasFecha(minDate, 1);
        }

        return (
            <DatePickerBlueColor
                value={stateinicioproyeccionextr}
                disabled={stateinicioproyeccion === null && statefinproyeccion === null}
                name="fechainicioproyeccionextr"
                id="fechainicioproyeccionextr"
                onChange={(e) => { setstateinicioproyeccionextr(e) }}
                min={minDate}
                filter={(date: Date) => isWeekday(date)}
                monthdropdown={true}
            // showDisabledMonthNavigation={true}
            // excludeDates={excludeDates}
            // dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        )


    }, [stateinicioproyeccion, statefinproyeccion,stateinicioproyeccionextr])

    const DatePickerFinProyeccionExtraordinaria= useMemo(() => {

        var minDate = new Date();

        if (stateinicioproyeccionextr !== null) {
            const finproyeccionExtrDate = new Date(stateinicioproyeccionextr);
            minDate = SumarDiasFecha(finproyeccionExtrDate, 1);
        }
        else {
            minDate = SumarDiasFecha(minDate, 1);
        }

        return (
            <DatePickerBlueColor
                value={statefinproyeccionextr}
                disabled={stateinicioproyeccionextr === null}
                name="fechafinproyeccionextr"
                id="fechafinproyeccionextr"
                onChange={(e) => { setstatefinproyeccionextr(e) }}
                min={minDate}
                filter={(date: Date) => isWeekday(date)}
                monthdropdown={true}
            // showDisabledMonthNavigation={true}
            // excludeDates={excludeDates}
            // dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        )


    }, [stateinicioproyeccion, statefinproyeccion,stateinicioproyeccionextr,statefinproyeccionextr])



    const DatePickerInicioAsignarPresupuesto = useMemo(() => {

        const disabledInicioProyeccion = stateinicioproyeccion === null && statefinproyeccion === null;

        const indicemesFechaActual = fechaActual.getMonth();
        const anioFechaActual = fechaActual.getFullYear();
        const sgteAnio = anioFechaActual + 1;

        var minDate = new Date();
        var maxDate = SumarDiasFecha(minDate, 1);


        if (statefinproyeccion === null) {
            return (
                <></>
            )
        }
        else {

            const finProyeccionDate = new Date(statefinproyeccion);

            //Si se encuentra en los ultimos meses del anio, fecha maxima para iniciar es los ultimos dias de abril del sgte anio
            if (indicemesFechaActual >= 4 && indicemesFechaActual <= 11) {
                maxDate = new Date(sgteAnio, 3, 30, 0, 0, 0)
            }
            //Si se encuentra en los primeros meses del anio, fecha maxima para iniciar es los primeros dias de abril del presente anio
            else if (indicemesFechaActual >= 0 && indicemesFechaActual <= 3) {
                maxDate = new Date(anioActual, 3, 30, 0, 0, 0)
            }



            minDate = SumarDiasFecha(finProyeccionDate, 1);

            return (
                <>
                    <Label>
                        Fecha desde
                    </Label>
                    <DatePickerBlueColor
                        value={stateinicioasigpresup}
                        disabled={disabledInicioProyeccion}
                        name="fechainicioasigpresup"
                        id="fechainicioasigpresup"
                        onChange={(e) => { setstateinicioasigpresup(e) }}
                        min={minDate}
                        max={maxDate}
                        filter={(date: Date) => isWeekday(date)}
                        monthdropdown={true}
                        showYearDropdown={true}
                    // showDisabledMonthNavigation={true}
                    // excludeDates={excludeDates}
                    // dayClassName={(date: Date) => isFeriado(date, props.feriados)}
                    />
                </>

            )
        }






    }, [stateinicioasigpresup, stateinicioproyeccion, statefinproyeccion])


    const DatePickerFinAsignarPresupuesto = useMemo(() => {

        const disabledFinAsignarPresupuesto = statefinproyeccion === null && stateinicioasigpresup === null;

        const indicemesFechaActual = fechaActual.getMonth();
        const anioFechaActual = fechaActual.getFullYear();
        const sgteAnio = anioFechaActual + 1;

        var minDate = new Date();


        if (statefinproyeccion === null) {
            return (
                <></>
            )
        }
        else {

            if (stateinicioasigpresup !== null) {
                const inicioAsignarPresupuestoDate = new Date(stateinicioasigpresup);

                minDate = SumarDiasFecha(inicioAsignarPresupuestoDate, 1);
            }

            const maxDate = new Date(minDate.getFullYear(), 11, 31, 0, 0, 0)

            // //Si se encuentra en los ultimos meses del anio, fecha maxima para iniciar es los ultimos dias de abril del sgte anio
            // if (indicemesFechaActual >= 9 && indicemesFechaActual <= 11) {
            //     maxDate = new Date(sgteAnio, 3, 30, 0, 0, 0)
            // }
            // //Si se encuentra en los primeros meses del anio, fecha maxima para iniciar es los primeros dias de abril del presente anio
            // else if (indicemesFechaActual >= 0 && indicemesFechaActual <= 3) {
            //     maxDate = new Date(anioActual, 3, 30, 0, 0, 0)
            // }

            return (
                <>
                    <Label>
                        Fecha hasta
                    </Label>
                    <DatePickerBlueColor
                        value={statefinasigpresup}
                        disabled={disabledFinAsignarPresupuesto}
                        name="fechainicioasigpresup"
                        id="fechainicioasigpresup"
                        onChange={(e) => { setstatefinasigpresup(e) }}
                        min={minDate}
                        max={maxDate}
                        filter={(date: Date) => isWeekday(date)}
                        monthdropdown={true}
                        showYearDropdown={true}
                    // showDisabledMonthNavigation={true}
                    // excludeDates={excludeDates}
                    // dayClassName={(date: Date) => isFeriado(date, props.feriados)}
                    />
                </>

            )
        }






    }, [stateinicioasigpresup, statefinasigpresup, statefinproyeccion])



    useEffect(() => {
        props.onChangeFecha("proyeccioninicio", stateinicioproyeccion ?? "");
    }, [stateinicioproyeccion])

    useEffect(() => {
        props.onChangeFecha("proyeccionfin", statefinproyeccion ?? "");
    }, [statefinproyeccion])

    useEffect(() => {
        props.onChangeFecha("asignacioninicio", stateinicioasigpresup ?? "");
    }, [stateinicioasigpresup])

    useEffect(() => {
        props.onChangeFecha("asignacionfin", statefinasigpresup ?? "");
    }, [statefinasigpresup])


    useEffect(() => {
        props.onChangeFecha("proyeccioninicioextr", stateinicioproyeccionextr ?? "");
    }, [stateinicioproyeccionextr])

    useEffect(() => {
        props.onChangeFecha("proyeccionfinextr", statefinproyeccionextr ?? "");
    }, [statefinproyeccionextr])

    return (
        <Card className="">
            <CardTitle className="cardHeaderParametrosPeriodos"> <span className='pl-3'>
                Periodos
                <span className='pl-3'>
                    <i
                        className="fas fa-info-circle"

                    />
                </span>

            </span></CardTitle>
            <CardBody className="cardBodyParametrosPeriodos">
                <Row>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}> Periodo de ingreso de la proyección anual de horas extras</span>
                    </Col>
                    <Col xl={6}>
                        <Label>
                            Fecha desde
                        </Label>
                        <DatePickerBlueColor
                            value={stateinicioproyeccion}
                            disabled={false}
                            name="fechainicioproyeccion"
                            id="fechainicioproyeccion"
                            onChange={(e) => { setstateinicioproyeccion(e) }}
                            min={fechaActual}
                            max={ultimaFechaAnio}
                            filter={(date: Date) => isWeekday(date)}
                            monthdropdown={true}
                        // showDisabledMonthNavigation={true}
                        // excludeDates={excludeDates}
                        // dayClassName={(date: Date) => isFeriado(date, props.feriados)}
                        />
                    </Col>
                    <Col xl={6}>
                        <Label>
                            Fecha hasta
                        </Label>
                        {
                            DatePickerFinProyeccion
                        }
                    </Col>
                </Row>

                <Row>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}> Periodo extraordinario para el ingreso de la proyección anual de horas extras
                        </span>
                    </Col>
                    <Col xl={6}>
                        <Label>
                            Fecha desde
                        </Label>
                        {
                            DatePickerInicioProyeccionExtraordinaria
                        }
                    </Col>
                    <Col xl={6}>
                        <Label>
                            Fecha hasta
                        </Label>
                        {
                            DatePickerFinProyeccionExtraordinaria
                        }
                    </Col>
                </Row>

                <Row>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}> Periodo de ingreso de la asignación presupuestaria de horas extras (GPE)</span>
                    </Col>

                    {
                        statefinproyeccion === null &&
                        <Col xl={12}>
                            <div className="small-error"> Para indicar fechas para asignar presupuesto, primero debe indicar el período de proyección</div>
                        </Col>
                    }

                    <Col xl={6}>
                        {DatePickerInicioAsignarPresupuesto}

                    </Col>
                    <Col xl={6}>
                        {DatePickerFinAsignarPresupuesto}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
